export interface PaymentProps {
  id: number;
  event: {
    name: string;
    type: string;
  };
  amountDue: number;
  paid: boolean;
  date: string;
}

export const payments: PaymentProps[] = [
    {
        id: 1,        
        event: {
            name: "Charles Leclerc Memorial",
            type: "Celebration of Life",
        },
        amountDue: 35,
        paid: true,
        date: "2025-09-23"
    },
    {
        id: 2,        
        event: {
            name: "Spring Charity Gala",
            type: "Fundraiser",
        },
        amountDue: 150,
        paid: true,
        date: "2025-03-15"
    },
    {
        id: 3,        
        event: {
            name: "Tech Innovation Conference",
            type: "Corporate Event",
        },
        amountDue: 220,
        paid: false,
        date: "2025-10-08"
    },
    {
        id: 4,        
        event: {
            name: "Johnson Family Reunion",
            type: "Private Event",
        },
        amountDue: 85,
        paid: true,
        date: "2025-07-22"
    },
    {
        id: 5,        
        event: {
            name: "Annual Shareholders Meeting",
            type: "Corporate Event",
        },
        amountDue: 180,
        paid: false,
        date: "2025-11-01"
    },
    {
        id: 6,        
        event: {
            name: "Summer Music Festival",
            type: "Entertainment",
        },
        amountDue: 95,
        paid: true,
        date: "2025-06-30"
    },
    {
        id: 7,        
        event: {
            name: "Product Launch - MaxTech Pro",
            type: "Corporate Event",
        },
        amountDue: 275,
        paid: true,
        date: "2025-08-14"
    },
    {
        id: 8,        
        event: {
            name: "Wedding - Anderson & Martinez",
            type: "Wedding",
        },
        amountDue: 125,
        paid: false,
        date: "2025-09-05"
    }
]
